import React, { PropsWithChildren, FC } from 'react';

const NoDataView: FC<PropsWithChildren<unknown>> = ({
	children,
}: PropsWithChildren<unknown>) => (
	<div className="BaseTable__no-items">
		<i>{children}</i>
	</div>
);

export default NoDataView;
